export default __webpack_public_path__ + "static/media/1v1_gold_header.0edbd10d.png";